import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { DatePipe, formatDate, VERSION } from '@angular/common';
import { MatDatepicker } from '@angular/material';
import * as _moment from 'moment';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting'
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LoaderService } from '../shared.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
const moment = _rollupMoment || _moment;
HighchartsExportData(Highcharts);
HighchartsExporting(Highcharts);


@Component({
  selector: 'app-inverter-details',
  templateUrl: './inverter-details.component.html',
  styleUrls: ['./inverter-details.component.scss'],

})
export class InverterDetailsComponent implements OnInit {

  private ResponseVerifiedNormalUserDayGraph: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserMonthGraph: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserYearGraph: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserLifeTimeGraph: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserInverterList: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserInverterDetails: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserParmeterAndValue: Subject<any> = new Subject();

  pipe = new DatePipe('en-US')
  version = VERSION;
  date1 = new Date();
  chosenYearDate: Date;
  chosenMonthDate: Date = new Date(2020, 0, 1);
  chosenSemesterDate: Date;
  chosenWeekDate: Date;
  chosenDate: Date;
  monthInputCtrl: FormControl = new FormControl(new Date(2020, 0, 1));
  tabselection: any;
  visible = true;
  modelDate = new Date();

  date = new FormControl(moment());
  connectedSolarCapacity: any;
  // tslint:disable-next-line:variable-name
  Inverter_Rating: any;
  currentPower: any;
  totalGenration: any;
  totalPeakPower: any;
  monthGeneration: any;
  totalGeneration: any;
  connectedSolarCapacityUnit: any;
  currentPowerUnit: any;
  totalTodaysGenerationUnit: any;
  totalPeakPowerUnit: any;
  monthGenerationUnit: any;
  totalGenerationUnit: any;
  public inverterform: FormGroup;
  public inverterformDate: FormGroup;
  public dayform: FormGroup;
  public monthform: FormGroup;
  public yearform: FormGroup
  public highcharts = Highcharts;
  public inverterList: any = [] ;
  public invName : any;
  public invId : any;
  public inverterListZE: any = [];
  public role: any;
  public roleName: any;
  public updateFlag: boolean = false;
  public selectedTabSection: string;
  public subDevice_id: any;
  public serial_no: any;
  public dayGraphObj: any = {};
  public graphDetailsArray: any = [];
  // tslint:disable-next-line:variable-name
  public categories_Day: any[];
  // tslint:disable-next-line:variable-name
  public data_Day: any[];
  public login_Id = localStorage.login_id;
  public parameterList: any = [];
  public valueList: any = [];
  public obj: { name: any; value: any; };
  public name: any;
  public value: any;
  public parameterAndValue: any = [];
  public parameterListRequestObject: { serial_no: any; sub_device_id: any; };
  public currentMonth: Date;
  public currentYear: Date;
  public month_Data: any[];
  public month_Categories: any[];
  public FormattedYear: string;
  public years_Categories: any[];
  public years_Data: any[];
  public graphMonthObj: { month: string; year: string; user_id: any; serial_no: any; sub_device_id: any; };
  public graphMonthZE: {  month: string; year: string; user_id: any };

  public graphMonthObjZE: { month: string; year: string; user_id: any; serial_no: any; sub_device_id: any; };

  public graphYearObj: { year: string; user_id: any; serial_no: any; sub_device_id: any; };
  public graphLifeTimeObj: { start_year: string; user_id: any; serial_no: any; sub_device_id: any; };
  public graphMonthObjInv: { month: string; year: string; user_id: any };
  public graphYearObjInv: { year: string; user_id: any};
  public graphLifeTimeObjInv: { year: string; user_id: any };
  public LifeTimeCategories: any[];
  public LifeTimeData: any[];
  public inverterDetails_id: any;
  public inverterDetailsObject: any = {};
  public inverterDetails: any;
  public maxDate = new Date();
  public editDateOfSelected: any;
  public selectedDate: any;
  public minDate = new Date(2017, 1, 1);
  public inverterEfficency: any;
  public DayPowerSumNormalUser: any;
  public DayPowerSumNormalUserInv: any;
  public DaySpcificYeildNormalUser: any;
  public DaySpcificYeildNormalUserInv: any;
  Inv_Data: any[];
  energy: any[];
  // tslint:disable-next-line: variable-name

  //after TESTING USE one chart option instade of repeat
  /** below charts for each inverters */
  chartOptions_Day = {
    chart: {
      type: 'spline'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Power (KW)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user  month
  chartOptions_Month = {
    chart: {
      type: 'column'
    },
    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user dashboard year
  chartOptions_Year = {
    chart: {
      type: "column"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user dashboard Life_time
  chartOptions_LifeTime = {
    chart: {
      type: "column"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  /** below charts for all inverters */
  chartOptions_DayInv = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user  month
  chartOptions_MonthInv = {
    chart: {
      type: 'column'
    },
    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user dashboard year
  chartOptions_YearInv = {
    chart: {
      type: "column"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  // graph for normal user dashboard Life_time
  chartOptions_LifeTimeInv = {
    chart: {
      type: "column"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };

  monthPowerSumNormalUser: any;
  monthSpcificYeildNormalUser: any;
  monthPowerSumNormalUserInv: any;
  monthSpcificYeildNormalUserInv: any;
  yearPowerSumNormalUser: number;
  yearPowerSumNormalUserInv: number;
  yearSpcificYeildNormalUser: number;
  yearSpcificYeildNormalUserInv: number;
  lifeLimePowerSumNormalUser: number;
  lifeLimePowerSumNormalUserInv:number;

  constructor(private toastr: ToastrService, private fb: FormBuilder, private router: Router, private dashboardService: DashboardService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }
    else if (this.role == '6') {
      this.roleName = 'ze';
    } else if (this.role == '7') {
      this.roleName = 'dg';
    }

  }

  ngOnInit() {
    // for normal user Drop Down form
    this.inverterform = this.fb.group({
      inverter_id: [null, Validators.required],
    });
    // for normal user Date select form
    this.dayform = this.fb.group({
      dayDate: ["", Validators.required],
    });
    // for normal user month select form
    this.monthform = this.fb.group({
      monthYear: ["", Validators.required],
    });
    // for normal user year select form
    this.yearform = this.fb.group({
      year: ["", Validators.required],
    });
    this.dayform.get('dayDate').setValue(new Date());
    this.selectedTabSection = 'Day';
    if (this.roleName == 'normal') {
      // console.log("test")
      this.getInverterList();
    }

    if (this.roleName == 'ze'|| this.roleName == 'dg') {

      this.getInverterListZE();
    }
    this.tabselection = 'parameter_trends'
  }

  // select inverter dropdown for normal user
  onChange(value) {
    //  console.log(this.inverterDetails_id);
    this.inverterDetails_id = value;
    for (let i = 0; i < this.inverterList.length; i++) {
      if (this.inverterList[i].id == value) {
        this.subDevice_id = this.inverterList[i].sub_device_id;
        this.serial_no = this.inverterList[i].serial_no;
      }
    }
    this.getInverterDetailsById();
    if (this.selectedTabSection == 'Day') {
      this.normalUserInverterDayGraph();
    } else if (this.selectedTabSection == 'Month') {
      this.normalUserInverterMonthGraph();
    } else if (this.selectedTabSection == 'Year') {
      this.normalUseInverterYearGraph();
    } else if (this.selectedTabSection == 'LifeTime') {
      this.normalUseInverterLifeTimeGraph();
    } else if (this.selectedTabSection == 'MonthInv') {
      this.normalUserInverterMonthGraphInv();
    } else if (this.selectedTabSection == 'YearInv') {
      this.normalUseInverterYearGraphInv();
    } else if (this.selectedTabSection == 'LifeTimeInv') {
      this.normalUseInverterLifeTimeGraphInv();
    }



    this.getParameterAndValueList();
  }
  onChangeZE(value) {
    this.inverterDetails_id = value;
    for (let i = 0; i < this.inverterListZE.length; i++) {
      if (this.inverterListZE[i].id == value) {
        this.subDevice_id = this.inverterListZE[i].sub_device_id;
        this.serial_no = this.inverterListZE[i].serial_no;
      }
    }
    this.getInverterDetailsByIdZE();
    if (this.selectedTabSection == 'Day') {
      this.normalUserInverterDayGraph_ZE();
    } else if (this.selectedTabSection == 'Month') {
      this.ZEUserInverterMonthGraph();
    } else if (this.selectedTabSection == 'Year') {
      this.normalUseInverterYearGraph_ZE();
    } else if (this.selectedTabSection == 'LifeTime') {
      this.normalUseInverterLifeTimeGraph_ZE();
    } else if (this.selectedTabSection == 'MonthInv') {
      this.ZEUserInverterMonthGraphInv();
    } else if (this.selectedTabSection == 'YearInv') {
      this.normalUseInverterYearGraphInv_ZE();
    } else if (this.selectedTabSection == 'LifeTimeInv') {
      this.normalUseInverterLifeTimeGraphInv_ZE();
    }

   this.getParameterAndValueListZE();
  }
/**normal user inverter wise graph stat */
  showAllLifeTimeGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.normalUseInverterLifeTimeGraph();
  }
  showAllYearGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(new Date());
    this.normalUseInverterYearGraph();
  }
  showAllMonthGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthform.get('monthYear').setValue(new Date());
    this.normalUserInverterMonthGraph();
  }
  showAllDayGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterDayGraph();
  }
/**normal user inverter wise graph end */

/**normal user all inverter graph start */
  showAllDayGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterDayGraphInv();
  }
  showAllLifeTimeGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.normalUseInverterLifeTimeGraphInv();
  }
  showAllYearGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(new Date());
    this.normalUseInverterYearGraphInv();
  }
  showAllMonthGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthform.get('monthYear').setValue(new Date());
    this.normalUserInverterMonthGraphInv();
  }

/**normal user all inverter graph END */



/**ze user inverter wise graph stat */
showAllLifeTimeGraphTabZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.normalUseInverterLifeTimeGraph_ZE();
}
showAllYearGraphTabZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.yearform.get('year').setValue(new Date());
  this.normalUseInverterYearGraph_ZE();
}
showAllMonthGraphTabZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.monthform.get('monthYear').setValue(new Date());
  this.ZEUserInverterMonthGraph();
}
showAllDayGraphTabZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.dayform.get('dayDate').setValue(new Date());
  this.normalUserInverterDayGraph_ZE();
}
/**ze user inverter wise graph end */

/**ze user all inverter graph start */
showAllDayGraphTabInvZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.dayform.get('dayDate').setValue(new Date());
  this.normalUserInverterDayGraphInvZE();
}
showAllLifeTimeGraphTabInvZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.normalUseInverterLifeTimeGraphInv_ZE();
}
showAllYearGraphTabInvZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.yearform.get('year').setValue(new Date());
  this.normalUseInverterYearGraphInv_ZE();
}
showAllMonthGraphTabInvZE(selectedTabSection) {
  this.selectedTabSection = selectedTabSection;
  this.monthform.get('monthYear').setValue(new Date());
  this.ZEUserInverterMonthGraphInv();
}

/**ze user all inverter graph END */



  // Day Graph for Normal User
  public normalUserInverterDayGraph() {
    this.dayGraphObj = {
      date:this.pipe.transform(this.dayform.controls['dayDate'].value, "dd-MM-yyyy"),
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }

    this.dashboardService.normalUserEnergyDayGraph(this.dayGraphObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserDayGraph))
      .subscribe(
        async result => {
          this.DayPowerSumNormalUser = 0;
          this.DaySpcificYeildNormalUser = 0;
          if (result.status) {
            this.DayPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.DaySpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
            this.categories_Day = [];
            this.data_Day = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].date_time) {
                let stringToSplit = this.graphDetailsArray[i].date_time;
                let x = stringToSplit.split(" ");
                this.categories_Day.push(x[1]);
                this.data_Day.push(Number(this.graphDetailsArray[i].power_generation));
              }
              this.chartOptions_Day.series = [{
                name: 'Power Generated in KW',
                data: this.data_Day
              },];
              this.chartOptions_Day.xAxis = [{
                categories: this.categories_Day
              },];
              this.updateFlag = true;
              // setTimeout(() => this.loadBidChartData(), 1000);

            }
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  public normalUserInverterDayGraphInv() {

    this.dayGraphObj = {
      date:this.pipe.transform(this.dayform.controls['dayDate'].value, "dd-MM-yyyy"),
      user_id: this.login_Id,
      }
    this.dashboardService.normalUserEnergyDayGraphInv(this.dayGraphObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserDayGraph))
      .subscribe(
        async result => {
          this.DayPowerSumNormalUserInv = 0;
          this.DaySpcificYeildNormalUserInv = 0;
          if (result.status) {
            // this.DayPowerSumNormalUserInv = (result.resultObject.total_energy).toFixed(2);
            // this.DaySpcificYeildNormalUserInv = (result.resultObject.specific_yield).toFixed(2);
            this.DayPowerSumNormalUserInv = result.resultObject.total_energy;
            this.DaySpcificYeildNormalUserInv = result.resultObject.specific_yield;
            this.Inv_Data = [];
            this.energy = [];
            var graphDetailsArray = result.resultObject.inverterInfo;
             for (let i = 0; i < graphDetailsArray.length; i++) {
              this.Inv_Data.push(graphDetailsArray[i].inv_name);
              this.energy.push(Number(graphDetailsArray[i].energy));
            }
              this.chartOptions_DayInv.series = [{
                name: 'Energy Generated in KWh',
                data: this.energy
              },];
              this.chartOptions_DayInv.xAxis = [{
                categories: this.Inv_Data
              },];
              this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  public normalUserInverterDayGraphInvZE() {

    this.dayGraphObj = {
      date:this.pipe.transform(this.dayform.controls['dayDate'].value, "dd-MM-yyyy"),
      user_id: this.login_Id,
      }
    this.dashboardService.normalUserEnergyDayGraphInv(this.dayGraphObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserDayGraph))
      .subscribe(
        async result => {
          this.DayPowerSumNormalUserInv = 0;
          this.DaySpcificYeildNormalUserInv = 0;
          if (result.status) {
            this.DayPowerSumNormalUserInv = result.resultObject.total_energy;
            this.DaySpcificYeildNormalUserInv = result.resultObject.specific_yield;
            this.Inv_Data = [];
            this.energy = [];
            var graphDetailsArray = result.resultObject.inverterInfo;
             for (let i = 0; i < graphDetailsArray.length; i++) {
              this.Inv_Data.push(graphDetailsArray[i].inv_name);
              this.energy.push(Number(graphDetailsArray[i].energy));
            }
              this.chartOptions_DayInv.series = [{
                name: 'Energy Generated in KWh',
                data: this.energy
              },];
              this.chartOptions_DayInv.xAxis = [{
                categories: this.Inv_Data
              },];
              this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // Dynamic monthgraph for normal user
  public normalUserInverterMonthGraph() {
   this.graphMonthObj = {
      month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
      year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.normalUserEnergyMonthGraph(this.graphMonthObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserMonthGraph))
      .subscribe(
        async result => {
          this.monthPowerSumNormalUser=0;
          this.monthSpcificYeildNormalUser=0;
          if (result.status) {
            this.monthPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.monthSpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
            this.month_Categories = [];
            this.month_Data = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].date) {
                this.month_Categories.push(this.graphDetailsArray[i].date);
                this.month_Data.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
              this.chartOptions_Month.series = [{
                name: 'Energy Generated in KWh',
                data: this.month_Data
              },];
              this.chartOptions_Month.xAxis = [{
                categories: this.month_Categories
              },];
              this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

// Dynamic monthgraph for ze user
public ZEUserInverterMonthGraph() {
  this.graphMonthObjZE = {
     month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
     year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
     user_id: this.login_Id,
     serial_no: this.serial_no,
     sub_device_id: this.subDevice_id
   }
   this.dashboardService.ZEUserEnergyMonthGraph(this.graphMonthObjZE)
     .pipe(takeUntil(this.ResponseVerifiedNormalUserMonthGraph))
     .subscribe(
       async result => {
         this.monthPowerSumNormalUser=0;
         this.monthSpcificYeildNormalUser=0;
         if (result.status) {
           this.monthPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
           this.monthSpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
           this.month_Categories = [];
           this.month_Data = [];
           this.graphDetailsArray = [];
           this.graphDetailsArray = result.resultObject;
           for (let i = 0; i < this.graphDetailsArray.length; i++) {
             if (this.graphDetailsArray[i].date) {
               this.month_Categories.push(this.graphDetailsArray[i].date);
               this.month_Data.push(Number(this.graphDetailsArray[i].power_generation));
             }
           }
             this.chartOptions_Month.series = [{
               name: 'Energy Generated in KWh',
               data: this.month_Data
             },];
             this.chartOptions_Month.xAxis = [{
               categories: this.month_Categories
             },];
             this.updateFlag = true;
         } else if (!result.status) {
           if (result.message == 'Unauthorised or Login Time-out') {
             this.toastr.info(result.message);
             this.router.navigate(["/login"]);
           } else {
             this.toastr.info(result.message);
           }
         }
       },
       err => {
         return console.error(err);
       }
     );
 }

 // Dynamic monthgraph for normal user
 public normalUserInverterMonthGraphInv() {
   this.graphMonthObjInv = {
    month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
    year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
    user_id: this.login_Id
  }
  this.dashboardService.normalUserEnergyMonthGraphInv(this.graphMonthObjInv)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserMonthGraph))
    .subscribe(
      async result => {
        this.monthPowerSumNormalUser=0;
        this.monthSpcificYeildNormalUser=0;
        if (result.status) {
          this.monthPowerSumNormalUserInv = result.resultObject.total_energy;
          this.monthSpcificYeildNormalUserInv = result.resultObject.specific_yield;
          this.month_Categories = [];
          this.month_Data = [];
          this.graphDetailsArray = [];
          this.graphDetailsArray = result.resultObject.inverter_info;
          for (let i = 0; i < this.graphDetailsArray.length; i++) {

              this.month_Categories.push(this.graphDetailsArray[i].inv_name);
              this.month_Data.push(Number(this.graphDetailsArray[i].energy));

          }
            this.chartOptions_MonthInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.month_Data
            },];
            this.chartOptions_MonthInv.xAxis = [{
              categories: this.month_Categories
            },];
            this.updateFlag = true;
        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(result.message);
          }
        }
      },
      err => {
        return console.error(err);
      }
    );
}


 // Dynamic monthgraph for normal user
 public ZEUserInverterMonthGraphInv() {
  this.graphMonthZE = {
   month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
   year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
   user_id: this.login_Id,

 }
 this.dashboardService.ZEUserEnergyMonthGraphInv(this.graphMonthZE)
   .pipe(takeUntil(this.ResponseVerifiedNormalUserMonthGraph))
   .subscribe(
     async result => {
       this.monthPowerSumNormalUser=0;
       this.monthSpcificYeildNormalUser=0;
       if (result.status) {
         this.monthPowerSumNormalUserInv = result.resultObject.total_energy;
         this.monthSpcificYeildNormalUserInv = result.resultObject.specific_yield;
         this.month_Categories = [];
         this.month_Data = [];
         this.graphDetailsArray = [];
         this.graphDetailsArray = result.resultObject.inverter_info;
         for (let i = 0; i < this.graphDetailsArray.length; i++) {

             this.month_Categories.push(this.graphDetailsArray[i].inv_name);
             this.month_Data.push(Number(this.graphDetailsArray[i].energy));

         }
           this.chartOptions_MonthInv.series = [{
             name: 'Energy Generated in KWh',
             data: this.month_Data
           },];
           this.chartOptions_MonthInv.xAxis = [{
             categories: this.month_Categories
           },];
           this.updateFlag = true;
       } else if (!result.status) {
         if (result.message == 'Unauthorised or Login Time-out') {
           this.toastr.info(result.message);
           this.router.navigate(["/login"]);
         } else {
           this.toastr.info(result.message);
         }
       }
     },
     err => {
       return console.error(err);
     }
   );
}

  // Dynamic year graph for normal user
  public normalUseInverterYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.normalUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserYearGraph))
      .subscribe(
        async result => {
          this.yearPowerSumNormalUser=0;
          this.yearSpcificYeildNormalUser=0;
          if (result.status) {
            this.yearPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.yearSpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
            this.years_Categories = [];
            this.years_Data = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].month) {
                this.years_Categories.push(this.graphDetailsArray[i].month);
                this.years_Data.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
            this.chartOptions_Year.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];
            this.chartOptions_Year.xAxis = [{
              categories: this.years_Categories
            },];
            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }


  // Dynamic year graph for normal user
  public normalUseInverterYearGraph_ZE() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.ZEUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserYearGraph))
      .subscribe(
        async result => {
          this.yearPowerSumNormalUser=0;
          this.yearSpcificYeildNormalUser=0;
          if (result.status) {
            this.yearPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.yearSpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
            this.years_Categories = [];
            this.years_Data = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].month) {
                this.years_Categories.push(this.graphDetailsArray[i].month);
                this.years_Data.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
            this.chartOptions_Year.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];
            this.chartOptions_Year.xAxis = [{
              categories: this.years_Categories
            },];
            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }
   // Dynamic year graph for normal user
   public normalUseInverterYearGraphInv() {

    this.graphYearObjInv = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id,

    }
    this.dashboardService.normalUserEnergyYearGraphInv(this.graphYearObjInv)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserYearGraph))
      .subscribe(
        async result => {
          this.yearPowerSumNormalUserInv=0;
          this.yearSpcificYeildNormalUserInv=0;
          if (result.status) {
            this.yearPowerSumNormalUserInv = result.resultObject.total_energy;
            this.yearSpcificYeildNormalUserInv = result.resultObject.specific_yield;
            this.years_Categories = [];
            this.years_Data = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject.inverter_info;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
                this.years_Categories.push(this.graphDetailsArray[i].inv_name);
                this.years_Data.push(Number(this.graphDetailsArray[i].energy));
            }
            this.chartOptions_YearInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];
            this.chartOptions_YearInv.xAxis = [{
              categories: this.years_Categories
            },];
            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // Dynamic year graph for normal user
  public normalUseInverterYearGraphInv_ZE() {

    this.graphYearObjInv = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id,

    }
    this.dashboardService.ZEUserEnergyYearGraphInv(this.graphYearObjInv)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserYearGraph))
      .subscribe(
        async result => {
          this.yearPowerSumNormalUserInv=0;
          this.yearSpcificYeildNormalUserInv=0;
          if (result.status) {
            this.yearPowerSumNormalUserInv = result.resultObject.total_energy;
            this.yearSpcificYeildNormalUserInv = result.resultObject.specific_yield;
            this.years_Categories = [];
            this.years_Data = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject.inverter_info;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
                this.years_Categories.push(this.graphDetailsArray[i].inv_name);
                this.years_Data.push(Number(this.graphDetailsArray[i].energy));
            }
            this.chartOptions_YearInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];
            this.chartOptions_YearInv.xAxis = [{
              categories: this.years_Categories
            },];
            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // Dynamic lifetime graph for normal user
  public normalUseInverterLifeTimeGraph() {

    this.graphLifeTimeObj = {
      start_year: "2017",
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.normalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserLifeTimeGraph))
      .subscribe(
        async result => {
          this.lifeLimePowerSumNormalUser=0;
          if (result.status) {
            this.lifeLimePowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.LifeTimeCategories = [];
            this.LifeTimeData = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].year) {
                this.LifeTimeCategories.push(this.graphDetailsArray[i].year);
                this.LifeTimeData.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
            this.chartOptions_LifeTime.series = [{
              name: 'Energy Generated in KWh',
              data: this.LifeTimeData
            },];

            this.chartOptions_LifeTime.xAxis = [{
              categories: this.LifeTimeCategories
            },];

            this.updateFlag = true;
            // setTimeout(() => this.loadBidLife_TimeChartData(), 1000);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

   // Dynamic lifetime graph for normal user
   public normalUseInverterLifeTimeGraph_ZE() {

    this.graphLifeTimeObj = {
      start_year: "2017",
      user_id: this.login_Id,
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.ZEUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserLifeTimeGraph))
      .subscribe(
        async result => {
          this.lifeLimePowerSumNormalUser=0;
          if (result.status) {
            this.lifeLimePowerSumNormalUser = (result.sum_power_gen).toFixed(2);
            this.LifeTimeCategories = [];
            this.LifeTimeData = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].year) {
                this.LifeTimeCategories.push(this.graphDetailsArray[i].year);
                this.LifeTimeData.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
            this.chartOptions_LifeTime.series = [{
              name: 'Energy Generated in KWh',
              data: this.LifeTimeData
            },];

            this.chartOptions_LifeTime.xAxis = [{
              categories: this.LifeTimeCategories
            },];

            this.updateFlag = true;
            // setTimeout(() => this.loadBidLife_TimeChartData(), 1000);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

   // Dynamic lifetime graph for normal user
   public normalUseInverterLifeTimeGraphInv() {
   this.graphLifeTimeObjInv = {
    year: "2017",
    user_id: this.login_Id
        }
    this.dashboardService.normalUserEnergyLifeTimeGraphInv(this.graphLifeTimeObjInv)
      .pipe()
      .subscribe(
        async result => {
          this.lifeLimePowerSumNormalUserInv=0;
          if (result.status) {
            this.lifeLimePowerSumNormalUserInv = result.resultObject.total_energy;
            this.LifeTimeCategories = [];
            this.LifeTimeData = [];
            this.graphDetailsArray = [];
            this.graphDetailsArray = result.resultObject.inverter_info;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].inv_name) {
                this.LifeTimeCategories.push(this.graphDetailsArray[i].inv_name);
                this.LifeTimeData.push(Number(this.graphDetailsArray[i].energy));
              }
            }
            this.chartOptions_LifeTimeInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.LifeTimeData
            },];

            this.chartOptions_LifeTimeInv.xAxis = [{
              categories: this.LifeTimeCategories
            },];

            this.updateFlag = true;
            // setTimeout(() => this.loadBidLife_TimeChartData(), 1000);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


   // Dynamic lifetime graph for normal user
   public normalUseInverterLifeTimeGraphInv_ZE() {
    this.graphLifeTimeObjInv = {
     year: "2017",
     user_id: this.login_Id
         }
     this.dashboardService.ZEUserEnergyLifeTimeGraphInv(this.graphLifeTimeObjInv)
       .pipe()
       .subscribe(
         async result => {
           this.lifeLimePowerSumNormalUserInv=0;
           if (result.status) {
             this.lifeLimePowerSumNormalUserInv = result.resultObject.total_energy;
             this.LifeTimeCategories = [];
             this.LifeTimeData = [];
             this.graphDetailsArray = [];
             this.graphDetailsArray = result.resultObject.inverter_info;
             for (let i = 0; i < this.graphDetailsArray.length; i++) {
               if (this.graphDetailsArray[i].inv_name) {
                 this.LifeTimeCategories.push(this.graphDetailsArray[i].inv_name);
                 this.LifeTimeData.push(Number(this.graphDetailsArray[i].energy));
               }
             }
             this.chartOptions_LifeTimeInv.series = [{
               name: 'Energy Generated in KWh',
               data: this.LifeTimeData
             },];

             this.chartOptions_LifeTimeInv.xAxis = [{
               categories: this.LifeTimeCategories
             },];

             this.updateFlag = true;
             // setTimeout(() => this.loadBidLife_TimeChartData(), 1000);

           } else if (!result.status) {
             if (result.message == 'Unauthorised or Login Time-out') {
               this.toastr.info(result.message);
               this.router.navigate(["/login"]);

             } else {
               this.toastr.info(result.message);

             }

           }
         },
         err => {
           return console.error(err);
         }
       );
   }



// Day Graph for ze User
public normalUserInverterDayGraph_ZE() {
  this.dayGraphObj = {
    date:this.pipe.transform(this.dayform.controls['dayDate'].value, "dd-MM-yyyy"),
    user_id: this.login_Id,
    serial_no: this.serial_no,
    sub_device_id: this.subDevice_id
  }

  this.dashboardService.zeUserEnergyDayGraph(this.dayGraphObj)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserDayGraph))
    .subscribe(
      async result => {
        this.DayPowerSumNormalUser = 0;
        this.DaySpcificYeildNormalUser = 0;
        if (result.status) {
          this.DayPowerSumNormalUser = (result.sum_power_gen).toFixed(2);
          this.DaySpcificYeildNormalUser = (result.specific_yeild).toFixed(2);
          this.categories_Day = [];
          this.data_Day = [];
          this.graphDetailsArray = [];
          this.graphDetailsArray = result.resultObject;
          for (let i = 0; i < this.graphDetailsArray.length; i++) {
            if (this.graphDetailsArray[i].date_time) {
              let stringToSplit = this.graphDetailsArray[i].date_time;
              let x = stringToSplit.split(" ");
              this.categories_Day.push(x[1]);
              this.data_Day.push(Number(this.graphDetailsArray[i].power_generation));
            }
            this.chartOptions_Day.series = [{
              name: 'Power Generated in KW',
              data: this.data_Day
            },];
            this.chartOptions_Day.xAxis = [{
              categories: this.categories_Day
            },];
            this.updateFlag = true;
            // setTimeout(() => this.loadBidChartData(), 1000);

          }
        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

  // get inverter list on drop Down normal user
  public getInverterList() {
    this.dashboardService.getInverterList()
      .pipe(takeUntil(this.ResponseVerifiedNormalUserInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            // result.resultObject.splice(result.resultObject.findIndex(value => value.sub_device_id != '1') , 1)
            for (let index = 0; index < result.resultObject.length; index++) {
              if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
                this.inverterList.push(result.resultObject[index]);
              }
            }
            // this.inverterList = result.resultObject;
            // this.loaderService.display(false);
            this.serial_no = this.inverterList[0].serial_no;
            this.subDevice_id = this.inverterList[0].sub_device_id;
            this.inverterDetails_id = this.inverterList[0].id;
            this.inverterform.get('inverter_id').setValue(this.inverterDetails_id)
            this.getParameterAndValueList();
            this.normalUserInverterDayGraph();
            this.getInverterDetailsById();
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // get inverter list on drop Down ze dg
  public getInverterListZE() {
    this.dashboardService.getInverterListZE()
      .pipe(takeUntil(this.ResponseVerifiedNormalUserInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            for (let index = 0; index < result.resultObject.length; index++) {
              if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
                this.inverterListZE.push(result.resultObject[index]);
              }
            }
            // this.inverterListZE = result.resultObject;
            // this.loaderService.display(false);
            this.serial_no = this.inverterListZE[0].serial_no;
            this.subDevice_id = this.inverterListZE[0].sub_device_id;
            this.inverterDetails_id = this.inverterListZE[0].id;
            this.inverterform.get('inverter_id').setValue(this.inverterDetails_id)
            this.getParameterAndValueListZE();
            this.normalUserInverterDayGraph_ZE();
            this.getInverterDetailsByIdZE();

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  showParameterTrendsTab(tab){
        this.tabselection = tab;
        this.selectedTabSection = 'Day'
        this.dayform.get('dayDate').setValue(new Date());
        this.normalUserInverterDayGraphInv();
      }
  showParameterTrendsTabZE(tab){
        this.tabselection=tab;
        this.selectedTabSection = 'Day'
        this.dayform.get('dayDate').setValue(new Date());
        this.normalUserInverterDayGraphInvZE();

          }

  showDownloadReportab(tab){
        this.tabselection=tab;
        this.selectedTabSection = 'Day'
        this.dayform.get('dayDate').setValue(new Date());
        this.normalUserInverterDayGraphInv();
      }
  showDownloadReportabZE(tab){
        this.tabselection=tab;
        this.selectedTabSection = 'Day'
        this.dayform.get('dayDate').setValue(new Date());
        this.normalUserInverterDayGraphInvZE();
      }
  // inverter Details Dashboard data for nomal user
  public getInverterDetailsById() {

    this.inverterDetailsObject = {
      inverter_id: this.inverterDetails_id
      // inverter_id: this.invId
    }
    this.dashboardService.getInverterDetailsById(this.inverterDetailsObject)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserInverterDetails))
      .subscribe(
        async result => {
          this.inverterDetails = [];
          if (result.status) {
            this.inverterDetails = result.resultObject;
            //   this.loaderService.display(false);
            var solarCapacity = this.inverterDetails[0].connected_solar_capacity;
            let a = solarCapacity.split(" ");
            this.connectedSolarCapacity = a[0];
            this.connectedSolarCapacityUnit = a[1];

            this.Inverter_Rating = this.inverterDetails[0].inverter_rating;

            var current = this.inverterDetails[0].current_power;
            let b = current.split(" ");
            this.currentPower = b[0];
            this.currentPowerUnit = b[1];

            var todysGen = this.inverterDetails[0].today_generation;
            let c = todysGen.split(" ");
            this.totalGenration = c[0];
            this.totalTodaysGenerationUnit = c[1];

            var peackPower = this.inverterDetails[0].today_peak_power;
            let d = peackPower.split(" ");
            this.totalPeakPower = d[0];
            this.totalPeakPowerUnit = d[1];

            var monthGen = this.inverterDetails[0].month_generation;
            let e = monthGen.split(" ");
            this.monthGeneration = e[0];
            this.monthGenerationUnit = e[1];

            var totalGen = this.inverterDetails[0].total_generation;
            let f = totalGen.split(" ");
            this.totalGeneration = f[0];
            this.totalGenerationUnit = f[1];
            this.inverterEfficency = Number(this.inverterDetails[0].inverter_efficiency).toFixed(2);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


 // inverter Details Dashboard data for ZE DG user
 public getInverterDetailsByIdZE() {

  this.inverterDetailsObject = {
    inverter_id: this.inverterDetails_id
  }
  this.dashboardService.getInverterDetailsByIdZE(this.inverterDetailsObject)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserInverterDetails))
    .subscribe(
      async result => {
        this.inverterDetails = [];
        if (result.status) {
          this.inverterDetails = result.resultObject;
          //   this.loaderService.display(false);
          var solarCapacity = this.inverterDetails[0].connected_solar_capacity;
          let a = solarCapacity.split(" ");
          this.connectedSolarCapacity = a[0];
          this.connectedSolarCapacityUnit = a[1];


          this.Inverter_Rating = this.inverterDetails[0].inverter_rating;

          var current = this.inverterDetails[0].current_power;
          let b = current.split(" ");
          this.currentPower = b[0];
          this.currentPowerUnit = b[1];

          var todysGen = this.inverterDetails[0].today_generation;
          let c = todysGen.split(" ");
          this.totalGenration = c[0];
          this.totalTodaysGenerationUnit = c[1];

          var peackPower = this.inverterDetails[0].today_peak_power;
          let d = peackPower.split(" ");
          this.totalPeakPower = d[0];
          this.totalPeakPowerUnit = d[1];

          var monthGen = this.inverterDetails[0].month_generation;
          let e = monthGen.split(" ");
          this.monthGeneration = e[0];
          this.monthGenerationUnit = e[1];

          var totalGen = this.inverterDetails[0].total_generation;
          let f = totalGen.split(" ");
          this.totalGeneration = f[0];
          this.totalGenerationUnit = f[1];
          this.inverterEfficency = Number(this.inverterDetails[0].inverter_efficiency).toFixed(2);

          console.log("inv details ***********"+solarCapacity)

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

  // inverter Details Dashboard data for wms user
  // public getwmsInverterDetailsById() {
  //   this.uploadFlagSpinner = true;
  //   this.wmsInverterDetailsObject = {
  //     inverter_id: this.wmsInverterDetails_id
  //   }
  //   this.dashboardService.getWmsInverterDetailsById(this.wmsInverterDetailsObject)
  //     .pipe(takeUntil(this.ResponseWmsInverterDetails))
  //     .subscribe(
  //       async result => {
  //         this.wmsInverterDetails=[];
  //         if (result.status) {
  //           this.wmsInverterDetails = result.resultObject;
  //           var solarCapacity = this.wmsInverterDetails[0].connected_solar_capacity;
  //           let a = solarCapacity.split(" ");
  //           this.wmsConnectedSolarCapacity = a[0];
  //           this.wmsConnectedSolarCapacityUnit = a[1];

  //           this.wmsInverter_Rating = this.wmsInverterDetails[0].inverter_rating;

  //           var current = this.wmsInverterDetails[0].current_power;
  //           let b = current.split(" ");
  //           this.wmscurrentPower = b[0];
  //           this.wmscurrentPowerUnit = b[1];

  //           var todysGen = this.wmsInverterDetails[0].today_generation;
  //           let c = todysGen.split(" ");
  //           this.wmstotalGenration = c[0];
  //           this.wmstotalTodaysGenerationUnit = c[1];

  //           var peackPower = this.wmsInverterDetails[0].today_peak_power;
  //           let d = peackPower.split(" ");
  //           this.wmstotalPeakPower = d[0];
  //           this.wmstotalPeakPowerUnit = d[1];

  //           var monthGen = this.wmsInverterDetails[0].month_generation;
  //           let e = monthGen.split(" ");
  //           this.wmsmonthGeneration = e[0];
  //           this.wmsmonthGenerationUnit = e[1];

  //           var totalGen = this.wmsInverterDetails[0].total_generation;
  //           let f = totalGen.split(" ");
  //           this.wmstotalGeneration = f[0];
  //           this.wmstotalGenerationUnit = f[1];
  //           this.inverterEfficency = this.wmsInverterDetails[0].inverter_efficiency;
  //           this.uploadFlagSpinner = false;
  //         }else if (!result.status) {
  //           if (result.message == 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(["/login"]);
  //             this.uploadFlagSpinner = false;
  //           } else {
  //             this.toastr.info(result.message);
  //             this.wmsConnectedSolarCapacity = 0;
  //             this.wmsConnectedSolarCapacityUnit = "";
  //             this.wmsInverter_Rating=0;
  //             this.wmscurrentPower = 0;
  //             this.wmscurrentPowerUnit = "";
  //             this.wmstotalGenration = 0;
  //             this.wmstotalTodaysGenerationUnit = "";
  //             this.wmstotalPeakPower = 0;
  //             this.wmstotalPeakPowerUnit = "";
  //             this.wmsmonthGeneration = 0;
  //           this.wmsmonthGenerationUnit = "";
  //           this.wmstotalGeneration = 0;
  //           this.wmstotalGenerationUnit = "";
  //           this.inverterEfficency=0;
  //             this.uploadFlagSpinner = false;
  //           }

  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  // Normal User Dashboard Parameters and value list
  public getParameterAndValueList() {

    this.parameterListRequestObject = {
      serial_no: this.serial_no,
      sub_device_id: this.subDevice_id
    }
    this.dashboardService.getParameterAndValueList(this.parameterListRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
      .subscribe(
        async result => {
          this.parameterAndValue = []
          if (result.status) {
            this.parameterAndValue = result.resultObject;
            //   this.loaderService.display(true);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

// Normal User Dashboard Parameters and value list
public getParameterAndValueListZE() {

  this.parameterListRequestObject = {
    serial_no: this.serial_no,
    sub_device_id: this.subDevice_id
  }
  this.dashboardService.getParameterAndValueListZE(this.parameterListRequestObject)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
    .subscribe(
      async result => {
        this.parameterAndValue = []
        if (result.status) {
          this.parameterAndValue = result.resultObject;
          //   this.loaderService.display(true);

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

  // year graph normal user
  chosenYearHandler() {
    this.normalUseInverterYearGraph();
    //   container.setViewMode('month');
  }
  changeYearInv(){
    this.normalUseInverterYearGraphInv();
  }


    // year graph ZE user
    chosenYearHandlerZE() {
      this.normalUseInverterYearGraph_ZE();
      //   container.setViewMode('month');
    }
    changeYearInvZE(){
      this.normalUseInverterYearGraphInv_ZE();
    }

  // month graph normal user
  chosenMonth() {
    this.normalUserInverterMonthGraph();
  }
  // month graph normal user
  chosenMonthZE() {
    this.ZEUserInverterMonthGraph();
  }

  changeMonthInv(){
    this.normalUserInverterMonthGraphInv();
  }

  changeMonthInvZE(){
    this.ZEUserInverterMonthGraphInv();
  }
  // day graph normal user
  onDayChange() {
    this.normalUserInverterDayGraph();
  }
  onDayChangeInv(){
    this.normalUserInverterDayGraphInv();
  }
// day graph normal user
   onDayChangeZE() {
     this.normalUserInverterDayGraph_ZE();
    }
   onDayChangeInvZE(){
  this.normalUserInverterDayGraphInvZE();
}


  ngOnDestroy() {
    // this.uploadFlagSpinner = false;

    this.ResponseVerifiedNormalUserDayGraph.next();
    this.ResponseVerifiedNormalUserDayGraph.complete();

    this.ResponseVerifiedNormalUserMonthGraph.next();
    this.ResponseVerifiedNormalUserMonthGraph.complete();

    this.ResponseVerifiedNormalUserYearGraph.next();
    this.ResponseVerifiedNormalUserYearGraph.complete();

    this.ResponseVerifiedNormalUserLifeTimeGraph.next();
    this.ResponseVerifiedNormalUserLifeTimeGraph.complete();

    this.ResponseVerifiedNormalUserInverterList.next();
    this.ResponseVerifiedNormalUserInverterList.complete();

    this.ResponseVerifiedNormalUserInverterDetails.next();
    this.ResponseVerifiedNormalUserInverterDetails.complete();

    this.ResponseVerifiedNormalUserParmeterAndValue.next();
    this.ResponseVerifiedNormalUserParmeterAndValue.complete();




  }

}
